import globals from '@descope-ui/theme-globals';
import {
  getThemeRefs,
  createHelperVars,
  useVar,
} from '@descope-ui/common/theme-helpers';
import { ListClass, componentName } from './component/ListClass';

const globalRefs = getThemeRefs(globals);

const compVars = ListClass.cssVarList;

const [helperTheme, helperRefs, helperVars] = createHelperVars(
  { shadowColor: '#00000020' },
  componentName,
);

const { shadowColor } = helperRefs;

const list = {
  ...helperTheme,

  [compVars.hostWidth]: '100%',
  [compVars.backgroundColor]: globalRefs.colors.surface.main,
  [compVars.fontFamily]: globalRefs.fonts.font1.family,
  [compVars.borderColor]: globalRefs.colors.surface.light,
  [compVars.borderStyle]: 'solid',
  [compVars.borderWidth]: globalRefs.border.xs,
  [compVars.borderRadius]: globalRefs.radius.sm,
  [compVars.gap]: globalRefs.spacing.md,
  [compVars.verticalPadding]: globalRefs.spacing.lg,
  [compVars.horizontalPadding]: globalRefs.spacing.lg,
  [compVars.boxShadow]: `${globalRefs.shadow.wide.sm} ${shadowColor}, ${globalRefs.shadow.narrow.sm} ${shadowColor}`,
  [compVars.maxHeight]: '100%',
  [compVars.hostDirection]: globalRefs.direction,
  [compVars.minItemsWidth]: '150px',
  [compVars.maxRowItems]: '1000', // effectively no limit

  _empty: {
    [compVars.minHeight]: '150px',
    [compVars.emptyStateTextColor]: globalRefs.colors.surface.dark,
    [compVars.emptyStateTextFontFamily]: globalRefs.fonts.font1.family,
  },

  variant: {
    tiles: {
      [compVars.gridTemplateColumns]: `repeat(auto-fit, minmax(
        max(
            min(${useVar(compVars.minItemsWidth)}, 100%),
                calc((100% - (${useVar(compVars.maxRowItems)} - 1) * ${useVar(compVars.gap)}) / ${useVar(compVars.maxRowItems)})),
        1fr))`,
      [compVars.maxItemsWidth]: '200px',
      [compVars.itemsHorizontalAlign]: 'center',
    },
  },

  gap: {
    xs: {
      [compVars.gap]: globalRefs.spacing.xs,
    },
    sm: {
      [compVars.gap]: globalRefs.spacing.sm,
    },
    md: {
      [compVars.gap]: globalRefs.spacing.md,
    },
    lg: {
      [compVars.gap]: globalRefs.spacing.lg,
    },
    xl: {
      [compVars.gap]: globalRefs.spacing.xl,
    },
  },
};

export default list;

export const vars = {
  ...compVars,
  ...helperVars,
};
